const toast = document.getElementById("toast-container");
const content = document.getElementById("toast-content");

const show = ({ title, message }) => {
  // Reset in case it's already visible
  toast.classList.remove("show");

  // Force reflow so transition restarts
  void toast.offsetWidth;

  content.innerHTML = `
    <div>
      ${title ? `<p class="font-bold text-black">${title}</p>` : ""}
      ${message ? `<p class="text-gray-500">${message}</p>` : ""}
    </div>
  `;

  // Show toast
  toast.classList.add("show");

  // Hide after 3s
  setTimeout(() => {
    toast.classList.remove("show");
  }, 5000);
};

const close = () => {
  toast.classList.remove("show");
};

window.Toast = { show, close };

document.addEventListener("click", (e) => {
  const showBtn = e.target.closest("[data-show-toast]");
  const closeBtn = e.target.closest("[data-close-toast]");

  if (!showBtn && !closeBtn) return;
  e.stopPropagation();
  e.preventDefault();
  if (showBtn) {
    const title = showBtn.getAttribute("data-title");
    const message = showBtn.getAttribute("data-message");

    show({ title, message });
  }
  if (closeBtn) close();
});
